/* CJ Attribution Tracker v3.1 - fbp + AddToCart intercept */
(function () {
  var ATTR_VERSION = 'v3.3-braid';
  var SESSION_TTL_MS = 30 * 60 * 1000;
  var CART_SYNC_TTL_MS = 5 * 60 * 1000;
  var TOUCHPOINT_MIN_INTERVAL_MS = 30 * 1000;

  function nowMs() { return Date.now(); }

  function safeJsonParse(v) {
    try { return JSON.parse(v); } catch (_e) { return null; }
  }

  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()\[\]\/+^]/g, '\\$&') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (_e) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    var maxAge = Math.max(1, Math.floor((days || 90) * 24 * 60 * 60));
    document.cookie = name + '=' + encodeURIComponent(String(value || '')) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function decodeParamValue(v) {
    if (v == null) return null;
    var raw = String(v);
    if (!raw.trim()) return null;
    try {
      return decodeURIComponent(raw.replace(/\+/g, ' ')).trim() || null;
    } catch (_e) {
      return raw.replace(/\+/g, ' ').trim() || null;
    }
  }

  function normalizeSource(source) {
    var s = String(source || '').trim().toLowerCase();
    if (!s) return null;
    if (s === 'facebook' || s === 'fb' || s === 'instagram' || s === 'ig' || s === 'meta') return 'meta';
    if (s === 'google' || s === 'adwords' || s === 'gads') return 'google';
    if (s === 'tiktok' || s === 'tt') return 'tiktok';
    if (s === 'bing') return 'bing';
    return s;
  }

  function detectDeviceType() {
    var ua = String(navigator.userAgent || '').toLowerCase();
    if (/ipad|tablet|playbook|silk/.test(ua)) return 'tablet';
    if (/mobi|android|iphone|ipod|windows phone/.test(ua)) return 'mobile';
    return 'desktop';
  }

  function detectCountryCode() {
    var host = String(window.location.hostname || '').toLowerCase();
    var firstLabel = host.split('.')[0] || '';
    if (/^[a-z]{2}$/.test(firstLabel)) return firstLabel;
    return null;
  }

  function parseQuery() {
    var query = String(window.location.search || '').replace(/^\?/, '');
    var map = {};
    if (query) {
      var parts = query.split('&');
      for (var i = 0; i < parts.length; i++) {
        var pair = parts[i];
        if (!pair) continue;
        var idx = pair.indexOf('=');
        var rawKey = idx >= 0 ? pair.slice(0, idx) : pair;
        var rawVal = idx >= 0 ? pair.slice(idx + 1) : '';
        var key = decodeParamValue(rawKey);
        if (!key) continue;
        map[String(key).toLowerCase()] = decodeParamValue(rawVal);
      }
    }

    function getAny(keys) {
      for (var j = 0; j < keys.length; j++) {
        var k = String(keys[j] || '').toLowerCase();
        var v = map[k];
        if (v != null && String(v).trim() !== '') return String(v).trim();
      }
      return null;
    }

    var out = {
      utm_source: getAny(['utm_source', 'source']),
      utm_medium: getAny(['utm_medium', 'medium']),
      utm_campaign: getAny(['utm_campaign', 'campaign', 'campaign_name']),
      utm_content: getAny(['utm_content', 'content', 'ad_name']),
      utm_ad_placement: getAny(['utm_ad_placement', 'ad_placement', 'placement']),
      utm_ad_set_name: getAny(['utm_ad_set_name', 'utm_adset_name', 'adset_name', 'utm_ad_set']),
      utm_ad_campaign_id: getAny(['utm_ad_campaign_id', 'campaign_id', 'utm_campaign_id', 'cj_c']),
      utm_ad_set_id: getAny(['utm_ad_set_id', 'adset_id', 'utm_adset_id', 'cj_as']),
      utm_ad_id: getAny(['utm_ad_id', 'ad_id', 'cj_ad']),
      utm_id: getAny(['utm_id']),
      utm_term: getAny(['utm_term', 'term']),
      fbclid: getAny(['fbclid']),
      gclid: getAny(['gclid']),
      gbraid: getAny(['gbraid']),
      wbraid: getAny(['wbraid']),
      ttclid: getAny(['ttclid', 'ttclidn'])
    };

    out.utm_source = normalizeSource(out.utm_source);
    if (!out.utm_source) {
      if (out.fbclid) out.utm_source = 'meta';
      else if (out.gclid || out.gbraid || out.wbraid) out.utm_source = 'google';
      else if (out.ttclid) out.utm_source = 'tiktok';
    }

    if (!out.utm_medium && (out.fbclid || out.gclid || out.gbraid || out.wbraid || out.ttclid)) {
      out.utm_medium = 'paid';
    }

    if (!out.utm_campaign && out.utm_ad_campaign_id) {
      out.utm_campaign = out.utm_ad_campaign_id;
    }

    return out;
  }

  function getOrCreateVisitorId() {
    var key = 'cj_visitor_id';
    var existing = localStorage.getItem(key);
    if (existing) return existing;

    var cookieFallback = getCookie('_cj_visitor_id');
    var id = cookieFallback || ('v_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10));
    localStorage.setItem(key, id);
    setCookie('_cj_visitor_id', id, 90);
    return id;
  }

  function getFbp() {
    var v = getCookie('_fbp');
    return v && String(v).trim() ? String(v).trim() : null;
  }

  function getFbc() {
    // 1. Meta pixel cookie (first-party)
    var fromCookie = getCookie('_fbc');
    if (fromCookie && String(fromCookie).trim()) return String(fromCookie).trim();
    // 2. Our own persisted fbc (survives ad blockers)
    var fromOwn = getCookie('_cj_fbc');
    if (fromOwn && String(fromOwn).trim()) return String(fromOwn).trim();
    try {
      var fromStorage = localStorage.getItem('cj_fbc');
      if (fromStorage && String(fromStorage).trim()) return String(fromStorage).trim();
    } catch (_e) {}
    return null;
  }

  function persistFbc(fbc) {
    if (!fbc) return;
    try { localStorage.setItem('cj_fbc', fbc); } catch (_e) {}
    setCookie('_cj_fbc', fbc, 90);
  }

  function extractFbpTs(fbp) {
    if (!fbp || typeof fbp !== 'string') return null;
    var parts = fbp.split('.');
    if (parts.length < 4) return null;
    var ts = Number(parts[2]);
    if (!Number.isFinite(ts) || ts <= 0) return null;
    if (ts > 1e12) ts = Math.floor(ts / 1000);
    return Math.floor(ts);
  }

  function buildFbc(fbclid, fbp) {
    if (!fbclid) return null;
    var ts = extractFbpTs(fbp) || Math.floor(nowMs() / 1000);
    return 'fb.1.' + String(ts) + '.' + String(fbclid);
  }

  function getSessionState(visitorId) {
    var key = 'cj_session_state';
    var state = safeJsonParse(sessionStorage.getItem(key)) || safeJsonParse(localStorage.getItem(key));
    var now = nowMs();

    if (!state || !state.session_id || !state.updated_at || (now - Number(state.updated_at || 0)) > SESSION_TTL_MS) {
      state = {
        session_id: visitorId + '_s_' + now + '_' + Math.random().toString(36).slice(2, 8),
        updated_at: now
      };
    } else {
      state.updated_at = now;
    }

    sessionStorage.setItem(key, JSON.stringify(state));
    localStorage.setItem(key, JSON.stringify(state));
    return state;
  }

  function readTouch(key) {
    return safeJsonParse(localStorage.getItem(key)) || null;
  }

  function writeTouch(key, touch) {
    localStorage.setItem(key, JSON.stringify(touch));
  }

  function mergeTouch(base, update) {
    var out = Object.assign({}, base || {});
    var keys = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'utm_ad_placement', 'utm_ad_set_name', 'utm_ad_campaign_id', 'utm_ad_set_id', 'utm_ad_id', 'utm_id',
      'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid'
    ];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (update && update[k] != null && String(update[k]).trim() !== '') out[k] = update[k];
    }
    return out;
  }

  function buildQueryFromTouch(touch) {
    var p = new URLSearchParams();
    var keys = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'utm_ad_placement', 'utm_ad_set_name', 'utm_ad_campaign_id', 'utm_ad_set_id', 'utm_ad_id', 'utm_id',
      'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid'
    ];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (touch && touch[k] != null && String(touch[k]).trim() !== '') p.set(k, String(touch[k]));
    }
    return p;
  }

  function decorateInternalLinks(touch) {
    var q = buildQueryFromTouch(touch);
    if (!q.toString()) return;
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) continue;
      try {
        var u = new URL(href, window.location.origin);
        if (u.origin !== window.location.origin) continue;
        if (u.pathname.startsWith('/cart') || u.pathname.startsWith('/checkout')) continue;
        q.forEach(function(v, k) {
          if (!u.searchParams.get(k)) u.searchParams.set(k, v);
        });
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (_e) {}
    }
  }

  function syncCartAttributes(visitorId, sessionId, fbp, fbc, touch) {
    try {
      var key = 'cj_cart_attr_last_sync';
      var last = Number(sessionStorage.getItem(key) || 0);
      if (nowMs() - last < CART_SYNC_TTL_MS) return;

      var attrs = {
        visitor_id: visitorId,
        session_id: sessionId,
        cj_visitor_id: visitorId,
        cj_fbp: fbp || '',
        cj_fbc: fbc || '',
        cj_utm_source: touch.utm_source || '',
        cj_utm_medium: touch.utm_medium || '',
        cj_utm_campaign: touch.utm_campaign || '',
        cj_utm_content: touch.utm_content || '',
        cj_utm_term: touch.utm_term || '',
        cj_utm_ad_placement: touch.utm_ad_placement || '',
        cj_utm_ad_set_name: touch.utm_ad_set_name || '',
        cj_utm_ad_campaign_id: touch.utm_ad_campaign_id || '',
        cj_utm_ad_set_id: touch.utm_ad_set_id || '',
        cj_utm_ad_id: touch.utm_ad_id || '',
        cj_utm_id: touch.utm_id || '',
        cj_fbclid: touch.fbclid || '',
        cj_gclid: touch.gclid || '',
        cj_gbraid: touch.gbraid || '',
        cj_wbraid: touch.wbraid || '',
        cj_ttclid: touch.ttclid || ''
      };

      if (cjConsentDenied()) { return; }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        credentials: 'same-origin',
        keepalive: true
      }).then(function () {
        sessionStorage.setItem(key, String(nowMs()));
      }).catch(function () {});
    } catch (_e) {}
  }

  function cjConsentDenied() {
    try {
      var cc = decodeURIComponent(getCookie('CookieConsent') || '');
      // True only when the visitor has answered the banner (stamp) AND declined marketing.
      return cc.indexOf('stamp:') > -1 && cc.indexOf('marketing:true') === -1;
    } catch (e) { return false; }
  }

  function sendNoCors(endpoint, payload) {
    var body = JSON.stringify(payload || {});
    try {
      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        body: body,
        keepalive: true,
        credentials: 'omit'
      }).catch(function () {});
    } catch (_e) {}
  }

  var visitorId = getOrCreateVisitorId();
  var sessionState = getSessionState(visitorId);
  var current = parseQuery();
  var fbp = getFbp();
  var countryCode = detectCountryCode();
  var deviceType = detectDeviceType();

  var firstTouch = readTouch('cj_attr_first_touch');
  var lastTouch = readTouch('cj_attr_last_touch');

  var hasAnySignal = !!(
    current.utm_source || current.utm_medium || current.utm_campaign || current.utm_content ||
    current.utm_ad_placement || current.utm_ad_set_name || current.utm_ad_campaign_id || current.utm_ad_set_id || current.utm_ad_id || current.utm_id ||
    current.fbclid || current.gclid || current.gbraid || current.wbraid || current.ttclid
  );

  if (hasAnySignal) {
    if (!firstTouch) {
      firstTouch = mergeTouch({}, current);
      firstTouch.captured_at = new Date().toISOString();
      writeTouch('cj_attr_first_touch', firstTouch);
    }
    // attrib-fix 2026-10-21: a different click id / ad id = NEW click -> replace last touch (no stale UTM merge) + force cart-attribute resync
    var cjNewClick = !!(lastTouch && ((current.fbclid && current.fbclid !== lastTouch.fbclid) || (current.gclid && current.gclid !== lastTouch.gclid) || (current.gbraid && current.gbraid !== lastTouch.gbraid) || (current.wbraid && current.wbraid !== lastTouch.wbraid) || (current.ttclid && current.ttclid !== lastTouch.ttclid) || (current.utm_ad_id && current.utm_ad_id !== lastTouch.utm_ad_id)));
    if (cjNewClick) { try { sessionStorage.removeItem('cj_cart_attr_last_sync'); } catch (_e) {} }
    lastTouch = mergeTouch(cjNewClick ? {} : (lastTouch || {}), current);
    lastTouch.captured_at = new Date().toISOString();
    writeTouch('cj_attr_last_touch', lastTouch);
  }

  var effective = mergeTouch(lastTouch || firstTouch || {}, current);

  // Build fbc AFTER effective is computed — fallback to stored fbclid from previous pages
  // attrib-fix: a fresh fbclid in the URL always wins over an older stored _fbc
  var cjOldFbc = String(getFbc() || '');
  var fbc = (current.fbclid && cjOldFbc.slice(-(current.fbclid.length + 1)) !== '.' + current.fbclid ? 'fb.1.' + nowMs() + '.' + current.fbclid : null) || getFbc() || buildFbc(current.fbclid, fbp) || buildFbc(effective.fbclid, fbp);
  // Persist fbc for cross-page survival (ad blockers prevent Meta setting _fbc)
  if (fbc) persistFbc(fbc);

  var sessionPayload = {
    visitor_id: visitorId,
    session_id: sessionState.session_id,
    utm_source: effective.utm_source || null,
    utm_medium: effective.utm_medium || null,
    utm_campaign: effective.utm_campaign || null,
    utm_content: effective.utm_content || null,
    utm_term: effective.utm_term || null,
    fbclid: effective.fbclid || null,
    gclid: effective.gclid || null,
    gbraid: effective.gbraid || null,
    wbraid: effective.wbraid || null,
    ttclid: effective.ttclid || null,
    fbp: fbp || null,
    fbc: fbc || null,
    landing_page: window.location.href,
    referrer: document.referrer || null,
    device: navigator.userAgent,
    consent_status: (function(){try{var cc=decodeURIComponent(getCookie('CookieConsent')||'');if(!cc||cc.indexOf('stamp:')===-1)return 'unknown';return cc.indexOf('marketing:true')>-1?'granted':'denied';}catch(e){return 'unknown';}})(),
    attribution_version: ATTR_VERSION,
    first_touch: firstTouch || null,
    last_touch: lastTouch || null
  };

  var touchpointPayload = {
    event_type: hasAnySignal ? 'ad_click' : 'page_visit',
    fbp: fbp,
    visitor_id: visitorId,
    session_id: sessionState.session_id,
    session_ts: new Date().toISOString(),
    utm_source: effective.utm_source || null,
    utm_medium: effective.utm_medium || null,
    utm_campaign: effective.utm_campaign || null,
    utm_content: effective.utm_content || null,
    utm_ad_placement: effective.utm_ad_placement || null,
    utm_ad_set_name: effective.utm_ad_set_name || null,
    utm_ad_campaign_id: effective.utm_ad_campaign_id || null,
    utm_ad_set_id: effective.utm_ad_set_id || null,
    utm_ad_id: effective.utm_ad_id || null,
    utm_id: effective.utm_id || null,
    utm_term: effective.utm_term || null,
    fbclid: effective.fbclid || null,
    gclid: effective.gclid || null,
    gbraid: effective.gbraid || null,
    wbraid: effective.wbraid || null,
    ttclid: effective.ttclid || null,
    page_url: window.location.href,
    referrer: document.referrer || null,
    country_code: countryCode,
    device_type: deviceType
  };

  decorateInternalLinks(effective);
  syncCartAttributes(visitorId, sessionState.session_id, fbp, fbc, effective);

  // Delayed re-check: capture _fbp after Meta pixel loads (race condition fix)
  setTimeout(function() {
    var newFbp = getFbp();
    if (newFbp && newFbp !== fbp) {
      fbp = newFbp;
      var newFbc = buildFbc(effective.fbclid, newFbp);
      if (newFbc) { fbc = newFbc; persistFbc(fbc); }
      sessionStorage.removeItem('cj_cart_attr_last_sync');
      syncCartAttributes(visitorId, sessionState.session_id, newFbp, fbc, effective);
    }
  }, 2000);

  var sessionEndpoint = 'https://t.carpathianjerky.com/api/track-session';
  var touchpointEndpoint = 'https://t.carpathianjerky.com/api/track-touchpoint';
  var junkHost = false;
  try {
    var h = String(location.hostname || '').toLowerCase();
    junkHost = (h === 'example.com' || h.endsWith('.example.com') || h === 'localhost');
  } catch (e) {}
  if (!junkHost && !cjConsentDenied()) { sendNoCors(sessionEndpoint, sessionPayload); }

  /* Rata REALA de consimtamant pe magazin (16 sep 2026 + 12 oct 2026).
     Retrimitem sesiunea pe Accept SI pe Decline: fara Decline, shop-ul avea
     deny=0% (doar unknown/granted) si dilua rata aparenta. */
  function cjReadConsentStatus() {
    try {
      var cc = decodeURIComponent(getCookie('CookieConsent') || '');
      if (!cc || cc.indexOf('stamp:') === -1) return 'unknown';
      return cc.indexOf('marketing:true') > -1 ? 'granted' : 'denied';
    } catch (e) { return 'unknown'; }
  }
  function cjResendSessionConsent() {
    try {
      var status = cjReadConsentStatus();
      if (status === 'unknown') return;
      var upd = {};
      for (var k in sessionPayload) { if (Object.prototype.hasOwnProperty.call(sessionPayload, k)) upd[k] = sessionPayload[k]; }
      upd.consent_status = status;
      upd.fbp = getFbp() || upd.fbp || null;
      upd.occurred_at = new Date().toISOString();
      sendNoCors(sessionEndpoint, upd);
    } catch (e) {}
  }
  window.addEventListener('CookiebotOnAccept', cjResendSessionConsent);
  window.addEventListener('CookiebotOnDecline', cjResendSessionConsent);

  /* Telemetrie consent_events (dash) — shown/accept/decline cu decision_ms. */
  (function cjConsentTelemetry() {
    var ENDPOINTS = ['https://t.carpathianjerky.com/api/consent/event','https://dash.carpathianjerky.com/api/consent/event'];
    var ENDPOINT = ENDPOINTS[0];
    var shownAt = Date.now();
    var sent = {};
    var lockedSid = null;
    var lockedVid = null;
    function surface() {
      try {
        var h = String(location.hostname || '');
        if (h === 'carpathianjerky.ro' || h === 'www.carpathianjerky.ro') return 'ro';
        var m = h.match(/^([a-z]{2})\.carpathianjerky\.com$/i);
        if (m) return m[1].toLowerCase();
        return 'com';
      } catch (e) { return 'com'; }
    }
    function language() {
      try {
        return String(document.documentElement.lang || 'en').toLowerCase().split('-')[0] || 'en';
      } catch (e) { return 'en'; }
    }
    function device() {
      return /Mobi|Android|iP(hone|ad|od)/i.test(navigator.userAgent || '') ? 'mobile' : 'desktop';
    }
    function categoriesFromCookie() {
      try {
        var cc = decodeURIComponent(getCookie('CookieConsent') || '');
        if (!cc || cc.indexOf('stamp:') === -1) return ['necessary'];
        var out = ['necessary'];
        if (cc.indexOf('preferences:true') > -1) out.push('preferences');
        if (cc.indexOf('statistics:true') > -1) out.push('statistics');
        if (cc.indexOf('marketing:true') > -1) out.push('marketing');
        return out;
      } catch (e) { return ['necessary']; }
    }
    function lockIds() {
      if (!lockedVid && sessionPayload.visitor_id) lockedVid = String(sessionPayload.visitor_id).slice(0, 128);
      if (!lockedSid) {
        var sid = String(sessionPayload.session_id || ('s' + Date.now()));
        if (sid.length < 16) sid = (sid + 'xxxxxxxxxxxxxxxx').slice(0, 16);
        lockedSid = sid.slice(0, 64);
      }
      return { sid: lockedSid, vid: lockedVid };
    }
    function post(type, decisionMs, cats) {
      if (sent[type]) return;
      sent[type] = true;
      var ids = lockIds();
      var body = {
        type: type,
        categories: cats || ['necessary'],
        surface: surface(),
        language: language(),
        device: device(),
        viewport: { width: Math.max(1, window.innerWidth || 1), height: Math.max(1, window.innerHeight || 1) },
        decision_ms: decisionMs,
        variant: (window.Cookiebot && window.Cookiebot.cjLite) ? 'cjlite' : 'cookiebot',
        session_id: ids.sid
      };
      if (ids.vid && /^[A-Za-z0-9_-]{8,128}$/.test(ids.vid)) body.visitor_id = ids.vid;
      try {
        var blob = new Blob([JSON.stringify(body)], { type: 'text/plain' });
        var sentOk = false;
        for (var ei = 0; ei < ENDPOINTS.length; ei++) {
          try {
            if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINTS[ei], blob)) { sentOk = true; break; }
          } catch (e) {}
        }
        if (!sentOk) {
          fetch(ENDPOINTS[0], { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors', credentials: 'omit' })
            .catch(function () {
              fetch(ENDPOINTS[1], { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors', credentials: 'omit' }).catch(function () {});
            });
        }
      } catch (e) {}
    }
    function onShown() {
      if (cjReadConsentStatus() !== 'unknown') return;
      shownAt = Date.now();
      post('shown', null, ['necessary']);
    }
    if (document.getElementById('cjcl') || document.getElementById('CybotCookiebotDialog')) onShown();
    else {
      var obs = new MutationObserver(function () {
        if (document.getElementById('cjcl') || document.getElementById('CybotCookiebotDialog')) {
          onShown();
          try { obs.disconnect(); } catch (e) {}
        }
      });
      try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 15000);
    }
    window.addEventListener('CookiebotOnAccept', function () {
      // Doar decizii pe acest pageview (Cookiebot.changed). Returning visitors
      // re-emit Accept fara shown → rate false (ex. GR 900%).
      if (!(window.Cookiebot && Cookiebot.changed)) return;
      var cats = categoriesFromCookie();
      var type = (cats.indexOf('marketing') > -1 && cats.indexOf('statistics') > -1 && cats.indexOf('preferences') > -1) ? 'accept_all' : 'accept_partial';
      if (type === 'accept_partial' && cats.length === 1) type = 'decline';
      post(type, Math.max(0, Date.now() - shownAt), cats);
    });
    window.addEventListener('CookiebotOnDecline', function () {
      if (!(window.Cookiebot && Cookiebot.changed)) return;
      post('decline', Math.max(0, Date.now() - shownAt), ['necessary']);
    });
  })();

  // ViewContent + AddToCart REMOVED 2026-05-27 — GTM Custom Pixel V9.2 + Attribution
  // Custom Pixel already handle these. Having them here created un-deduplicable duplicate
  // CAPI events that dragged down EMQ. Session tracking + touchpoints remain.

  /* Cheie STATICA. Varianta per-vizitator ('..._' + fbp) genera o cheie noua de
     sessionStorage pentru fiecare om si umplea scanul Cookiebot cu intrari
     Unclassified. Fixul exista din 16 sep 2026 dar traia doar in tema
     NEPUBLICATA 184813453577 — vezi theme-io-stale-theme-id. */
  var throttleKey = 'cj_touchpoint_last_sent';
  var lastTouchSent = Number(sessionStorage.getItem(throttleKey) || 0);
  if (!cjConsentDenied() && (nowMs() - lastTouchSent >= TOUCHPOINT_MIN_INTERVAL_MS || hasAnySignal)) {
    sendNoCors(touchpointEndpoint, touchpointPayload);
    sessionStorage.setItem(throttleKey, String(nowMs()));
  }
})();